import { PaginationType } from "../../Types/APITypes";
import API from "./API";

class ParentAPI extends API {
  static get_parents = (pagination?: PaginationType) => {
    return this.getRequest(
      `parents?page=${pagination?.current_page || 1}&per_page=${pagination?.per_page || 10}${pagination?.search_word ? `&query=${pagination.search_word}` : ""}`,
      true
    );
  };

  static get_parent = (id: number) => {
    return this.getRequest(`parents/${id}/show`, true);
  };

  static update_parent = (
    id: number,
    data: {
      first_name?: string;
      last_name?: string;
      civility?: string;
      phone_number?: string;
      address_line_1?: string;
      zip_code?: string;
      city?: string;
      country?: string;
    }
  ) => {
    return this.putRequest(`parents/${id}/update`, data, true);
  };
}

export default ParentAPI;
